import { Create } from "react-admin";
import SaveForm from "./SaveForm";
import BackButtonToolbar from "features/BackButtonToolbar";

const CreatePreparatoryCourses = () => {
  return (
    <Create
      title="Създаване на подготвителни курсове"
      actions={<BackButtonToolbar />}
    >
      <SaveForm isCreate={true} />
    </Create>
  );
};
export default CreatePreparatoryCourses;
